import { Button } from "@/components/ui/button";
import { ArrowDown, Bot, Clock, TrendingUp } from "lucide-react";
import { ContactForm } from '@/components/LazyContactForm';
import { useContactForm } from '@/hooks/useContactForm';
import { useMetaPixel } from '@/hooks/useMetaPixel';

const Hero = () => {
  const { isContactFormOpen, openContactForm, closeContactForm } = useContactForm();
  const { trackContact, trackViewContent, trackInitiateCheckout } = useMetaPixel();

  const handleContactClick = () => {
    trackContact();
    trackInitiateCheckout();
    openContactForm();
  };
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center px-4 sm:px-6 lg:px-8 overflow-hidden pt-16">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-subtle -z-10" />
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-primary-glow/5 rounded-full blur-3xl animate-float" style={{ animationDelay: '-3s' }} />

      <div className="mx-auto max-w-7xl text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/50 rounded-full text-accent-foreground text-sm font-medium mb-6 animate-fade-in">
          <Bot size={16} />
          A IA que aumenta seu faturamento com consistência
        </div>

        {/* Main Headline */}
        <h1 className="text-hero text-foreground mb-6">
          Vendas 24/7 com a IA que{" "}
          <span className="bg-gradient-hero bg-clip-text text-transparent">
            agenda
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-subheading text-muted-foreground max-w-4xl mx-auto mb-10 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          Responde, qualifica e agenda leads em minutos sem depender do seu time estar online.
        </p>

        {/* Value Proposition */}
        <div className="flex flex-wrap justify-center items-center gap-8 mb-10 text-body-large animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <div className="flex items-center gap-2 text-muted-foreground">
            <TrendingUp size={20} className="text-primary" />
            <span>Até <strong className="text-foreground">5x mais oportunidades</strong></span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Clock size={20} className="text-primary" />
            <span>Gastando <strong className="text-foreground">3x menos tempo</strong></span>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center mb-12 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
          <Button variant="hero" size="xl" className="min-w-[200px]" onClick={handleContactClick}>
            Falar com Especialista
          </Button>
        </div>

        {/* Scroll Indicator */}
        <div className="animate-bounce">
          <ArrowDown size={24} className="text-muted-foreground mx-auto" />
        </div>
      </div>
      
      <ContactForm isOpen={isContactFormOpen} onClose={closeContactForm} />
    </section>
  );
};

export default Hero;